/*import MenuList from 'components/molecules/MenuList/MenuList'
import { menuOptions } from 'utils/menuOptions'
import { usePermissions } from '../../../hooks/usePermissions'

const Menu = () => {
    const { filterBy } = usePermissions()

    const visibleItems = filterBy(menuOptions, (item) =>
        item.permission ? [item.permission] : undefined
    )

    return (
        <div className="w-1/6">
            <div className="sticky top-10">
                <div className="mt-12 flex justify-center">
                    <img
                        src={require('../../../assets/Icon.png')}
                        className="img-logo"
                        alt="Logo"
                    />
                </div>
                <div className="flex justify-center mt-10">
                    <MenuList data={visibleItems} />
                </div>
            </div>
        </div>
    )
}

export default Menu */
import React, { useState } from 'react'
import MenuList from 'components/molecules/MenuList/MenuList'
import { menuOptions } from 'utils/menuOptions'
import { DynamicIcon } from 'components/atoms/Icons'
import { useSelector } from 'react-redux'
import { RootState } from 'store/store'

const Menu = () => {
    const [isCollapsed, setIsCollapsed] = useState(false)
    const userState = useSelector((state: RootState) => state.user)
    const storedUser = userState?.user

    return (
        <div
            className={`h-screen bg-white border-r border-gray-200 flex flex-col sticky top-0 rounded-t-2xl shadow-lg transition-all duration-300 ${
                isCollapsed ? 'w-16' : 'w-[228px]'
            }`}
        >
            {/* Header */}
            <div
                className={`p-5 flex items-start ${isCollapsed ? 'justify-center' : 'justify-between'}`}
            >
                {!isCollapsed && (
                    <div className="flex justify-start flex-1">
                        <DynamicIcon name={'logo'} />
                    </div>
                )}
                <button
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    className={`p-1 hover:bg-gray-100 rounded transition-colors flex-shrink-0 ${isCollapsed ? 'ml-0' : ''}`}
                    aria-label="Toggle menu"
                    title={isCollapsed ? 'Expandir menú' : 'Colapsar menú'}
                >
                    {isCollapsed ? (
                        <DynamicIcon name={'short'} className="w-5 h-5" />
                    ) : (
                        <DynamicIcon
                            name={'sidebar'}
                            className="w-6 h-6 py-2 px-1"
                        />
                    )}
                </button>
            </div>
            <div
                className={`flex items-center gap-3 px-5 pb-3 ${isCollapsed ? 'hidden' : ''}`}
            >
                <div className="flex flex-col">
                    <p className="text-sm font-medium text-gray-900 truncate">
                        {storedUser?.company?.name ?? 'Empresa'}
                    </p>
                    <p className="text-xs text-gray-500 truncate">
                        {storedUser?.warehouse?.name ?? ''}
                    </p>
                </div>
            </div>

            {/* Menu Content */}
            <div
                className={`flex-1 overflow-y-auto ${isCollapsed ? 'px-2 py-6' : 'px-5 py-6'}`}
            >
                <MenuList data={menuOptions} isCollapsed={isCollapsed} />
            </div>
        </div>
    )
}

export default Menu
